import { render, staticRenderFns } from "./BpcMiniContact.vue?vue&type=template&id=4b55298f&scoped=true&"
import script from "./BpcMiniContact.vue?vue&type=script&lang=js&"
export * from "./BpcMiniContact.vue?vue&type=script&lang=js&"
import style0 from "./BpcMiniContact.vue?vue&type=style&index=0&id=4b55298f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55298f",
  null
  
)

export default component.exports